<template>
  <div>
    <HomeProductsMobile v-if="isSmallScreen" />
    <HomeProductsDesktop v-else />
  </div>
</template>

<script>
import HomeProductsDesktop from '@/components/home/HomeProductsDesktop.vue';
import HomeProductsMobile from '@/components/home/HomeProductsMobile.vue';

export default {
  name: 'HomeProducts',

  components: {
    HomeProductsDesktop,
    HomeProductsMobile,
  },

  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },
};
</script>
